import axios from 'axios';
import * as dayjs from 'dayjs';
import * as accounting from 'accounting';
export const ABS_PATH = window.location.host === "localhost:3000" ? "http://localhost:3000" : "https:procurementmonitor.org/gwapp/";


String.prototype.trunc =
function (n, useWordBoundary) {
    if (this.length <= n) { return this; }
    var subString = this.substr(0, n - 1);
    return (useWordBoundary
        ? subString.substr(0, subString.lastIndexOf(' '))
        : subString) + "...";
};

export const truncate = (str, n) => {
    return str.length > n ? str.slice(0, n - 1) + " ..." : str;
};

export const ppdcLogoUrl = 'https://firebasestorage.googleapis.com/v0/b/auth-f9812.appspot.com/o/systemimages%2Fppdc.jpg?alt=media&token=94b6c06a-98e2-4683-a40c-d98a6f7b8b59';


export const currencyCodes  = {
    'NGN': "₦",
    'USD': "$",
    'GBP': "£",
    'EUR': "€"
}
export const currencyWord  = {
    'NGN': "naira",
    'USD': "dollars",
    'GBP': "pounds",
    'EUR': "euros"
}
export const currencySubWord  = {
    'NGN': "kobo",
    'USD': "cents",
    'GBP': "pence",
    'EUR': "cents"
}




// numToWords :: (Number a, String a) => a -> String
export const numToWords = s => {
    var th = ['','thousand','million', 'billion','trillion'];
		var dg = ['zero','one','two','three','four', 'five','six','seven','eight','nine'];
		var tn = ['ten','eleven','twelve','thirteen', 'fourteen','fifteen','sixteen', 'seventeen','eighteen','nineteen'];
		var tw = ['twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety']; 
		
		s = (s||'').toString(); s = s.replace(/[\, ]/g,''); if (s !== parseFloat(s)) return 'not a number'; var x = s.indexOf('.'); if (x === -1) x = s.length; if (x > 15) return 'too big'; var n = s.split(''); var str = ''; var sk = 0; for (var i=0; i < x; i++) {if ((x-i)%3===2) {if (n[i] === '1') {str += tn[Number(n[i+1])] + ' '; i++; sk=1;} else if (n[i]!==0) {str += tw[n[i]-2] + ' ';sk=1;}} else if (n[i]!==0) {str += dg[n[i]] +' '; if ((x-i)%3===0) str += 'hundred ';sk=1;} if ((x-i)%3===1) {if (sk) str += th[(x-i-1)/3] + ' ';sk=0;}} if (x !== s.length) {var y = s.length; str += 'point '; for (let i=x+1; i<y; i++) str += dg[n[i]] +' ';} return str.replace(/\s+/g,' ');
};


export const converNumtoWord = (number, currency)=>{
    let bits = ""+ parseFloat(number);
    bits = bits.split('.');
    console.log(bits);
    let firspart = "" + numToWords(parseInt(bits[0])) + currencyWord[currency];
    let seconpart = bits[1] ? ", " + numToWords(parseInt(bits[1])) + currencySubWord[currency]: "";

    return firspart + seconpart
}

export const total = (items)=>{
    let tots = 0;
    items.map((item)=>{
        tots += item.amount == ''? 0 : parseFloat(item.amount)
    })
    return tots.toFixed(2)
}

export const setClaims = async (email, claims)=>{
    let obj = {email, claims};
    console.log(obj)
    let result = await axios.post(cloudURL + 'setClaim?email='+email, claims)
    console.log({result});
}

export const claimTruth = (claims, status)=>{
    let truths = validStatuses(claims);
    return truths.includes(status)
    


}

export const validStatuses = (claims) =>{
    let fields = {};
    let template = {
        holderCheck : 1,
        reviewed: 1,
        checked: 1,
        pending: 1,
        uploaded: 1
    }
    if(claims.admin){
        const {holderCheck } = template;
        fields = {...fields, holderCheck }
    }
    if(claims.master){
        const {reviewed, uploaded } = template;
        fields = {...fields, reviewed, uploaded};
    }
    if(claims.budgetHolder){
        const {pending} = template;
        fields = {...fields, pending};
    }
    if(claims.reviewer){
        const { checked}  = template;
        fields = {...fields, checked};
    }

    return Object.keys(fields);
}

export const pdfTable = async (dataObject)=>{
    let logUrl = await tobase64(ppdcLogoUrl);
    let today = dayjs().format('DD MMM YYYY')
    let head = dataObject[0];
    let headers = Object.keys(head);
    let body = [headers];
    dataObject.forEach((proj)=>{
        let row = [];
         proj.date = dayjs(Math.abs(proj.date)).format("YYYY/MM/DD");
         proj.time = dayjs(Math.abs(proj.time)).format("YYYY/MM/DD");
         proj.total = accounting.formatMoney(proj.total, currencyCodes[proj.currency]);
        Object.keys(proj).forEach(key=>{
            let obj = {text: proj[key], style: 'labelStyle'};
            row.push(obj);
        })
        body.push(row);
    });
    var dd = {
        header: {
            columns: [
                {
                    image: logUrl,
                    width: 100,
                    height: 30,
                    margin: [10, 30]
                },
                {
                    text: today,
                    margin: [130, 0, 0, 0],
                    style: 'reference'
                }],
            margin: [20, 10]
        },
        footer: {
            text: 'Gwapp 2.0',
            style: 'footerStyle'
        },
        content: [
            {
                text: 'Requisitions',
                style: 'subheader'
            },
            {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: [70, '*', 35, 35, 25, 25, 30, 30, 30],
                    body: body
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex % 2 === 0) ? '#CCCCCC' : null;
                    }
                }
            },
        ],
        
        styles: {
            reference: {
                color: '#08713E'
            },
    
            header: {
                fontSize: 24,
                alignment: 'center',
                margin: [0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                color: "#CEAFE7",
                margin: [0, 15]
            },
            labelStyle: {
                bold: true,
                fontSize: 10,
                margin: [0, 10, 0, 3]
            },
            fieldStyle: {
                fontSize: 12,
                margin: [0, 3, 0, 5],
                color: "#B7ADAD"
            },
            tableExample: {
                margin: [0, 0]
            },
            tableBodyText: {
                fontSize: 10,
                italics: true,
            },
            dateStyle: {
                alignment: 'center',
                fontSize: '10',
                bold: true,
                color: "#CEAFE7"
            },
            footerStyle: {
                alignment: 'center',
                fontSize: 8,
                margin: [0, 0],
                italics: true,
                color: '#CEAFE7'
            }
        },
       


    }
    
    return dd;
}

const conversationsToDoc = (conversations)=>{
    let conversationElements = [{text: 'Dialog', style: 'subheader'}]
    conversations.forEach((conversation)=>{
        let time = dayjs(Math.abs(conversation.time)).format('DD MMM at h:mm a');
        conversationElements.push({
            columns:[
                {text: conversation.senderName, style: 'labelStyle'},
                {text: time, style: 'chatDateStyle'}
                ]
        });
        conversationElements.push({
            text: conversation.message,
            style: 'fieldStyle'
        })
    });

    return conversationElements;
}

export const printDocument = async (req, conversations) => {
    console.log(req);
    
    let SignatureSection, SourceSection, ref;
    let userDate = dayjs(Math.abs(req?.date)).format('DD/MM/YYYY');
    let budgetHolderDate = dayjs(Math.abs(req?.hoderCheckDate)).format('DD/MM/YYYY');
    let checkDate = dayjs(Math.abs(req?.checkedDate)).format('DD/MM/YYYY');
    let approveDate = dayjs(Math.abs(req?.approvedDate)).format('DD/MM/YYYY');
    let reqDate = dayjs(Math.abs(req.date));
    let date = reqDate.format('DD MMM YYYY');
    let title = "PAYMENT VOUCHER"
    let userSignature =  await tobase64(req.user.signatureUrl);
    let approveSignature = await tobase64(req?.approvedBy?.signatureUrl);
    let logoUrl = await tobase64(ppdcLogoUrl);
    if(req.type === "Fund Req"){
        let num = req.pvNumber ? req.pvNumber : req.countRef ? req.countRef : req.id.substr(0,10)
        ref = reqDate.format('DD-MM-YY') + "-" + req.projectName.substr(0,3).toUpperCase() + "-" + num;
        // let budgetHolderSig = await tobase64("https://firebasestorage.googleapis.com/v0/b/auth-f9812.appspot.com/o/signatures%2Fdr-toyin.jpeg?alt=media&token=45ea5f32-f002-467d-bc51-ee867c72df5b");
        let budgetHolderSig = await tobase64(req?.holderCheck?.signatureUrl);
        let checkedSignature = await tobase64(req?.checkedBy?.signatureUrl);
        SignatureSection = [
            [{ text: 'Raised By', style: 'labelStyle' }, { text: req.user.name, style: 'fieldStyle' }, { text: userDate, style: 'fieldStyle' }, { image: userSignature, width: 30, height: 30 }],
            [{ text: 'Budget Holder', style: 'labelStyle' }, { text: req.holderCheck.name, style: 'fieldStyle' }, { text: budgetHolderDate, style: 'fieldStyle' }, { image: budgetHolderSig, width: 30, height: 30 }],
            [{ text: 'Checked By', style: 'labelStyle' }, { text: req.checkedBy.name, style: 'fieldStyle' }, { text: checkDate, style: 'fieldStyle' }, { image: checkedSignature, width: 30, height: 30 }],
            [{ text: 'Approved By', style: 'labelStyle' }, { text: req?.approvedBy?.name || "", style: 'fieldStyle' }, { text: approveDate, style: 'fieldStyle' }, { image: approveSignature, width: 30, height: 30 }],
        ]

        SourceSection = [
            [
                {
                    text: 'Project Name',
                    style: 'labelStyle',
                },
                {
                    text: req.projectName,
                    style: 'fieldStyle'
                }
            ],
            [
                {
                    text: 'Source Bank Name',
                    style: 'labelStyle',
                },
                {
                    text: req.sourceBankName,
                    style: 'fieldStyle'
                }
            ],
            [{
                text: 'Source Account Number',
                style: 'labelStyle',
            },
            {
                text: req.sourceAccountNumber,
                style: 'fieldStyle'
            }

            ]
        ]
    }
    else{
        ref =   reqDate.format('DD-MM-YY') + req.id.substr(0,10)+ "-"+ "PET";
        SignatureSection = [
            [{ text: 'Raised By', style: 'labelStyle' }, { text: req.user.name, style: 'fieldStyle' }, { text: userDate, style: 'fieldStyle' }, { image: userSignature, width: 30, height: 30 }],
            [{ text: 'Approved By', style: 'labelStyle' }, { text: req.approvedBy.name, style: 'fieldStyle' }, { text: approveDate, style: 'fieldStyle' }, { image: approveSignature, width: 30, height: 30 }],
        ]
        SourceSection = []
       
    }
    let convos = []
    if(conversations.length > 0){
        convos = conversationsToDoc(conversations);
    }
    
    let itemsDoc = [[{ text: 'Item Description', style: 'labelStyle' }, { text: 'Budget Line', style: 'labelStyle' }, { text: 'Amount', style: 'labelStyle' }]];
    req.items.forEach((item) => {
        let row = [{ text: item.title, style: 'tableBodyText' }, { text: item.code || 'none', style: 'tableBodyText' }, { text: accounting.formatMoney(item.amount, currencyCodes[req.currency]), style: 'tableBodyText' }];
        itemsDoc.push(row);
    })
    var dd = {
        
        footer: {
            text: 'Gwapp 2.0',
            style: 'footerStyle'
        },
        content: [
            {
                columns: [
                    {
                        image: logoUrl,
                        width: 100,
                        height: 30
                    },
                    {
                        text: ref,
                        margin: [130, 0, 0, 0],
                        style: 'Voucher Number'
                    }]

            },
            {
                text: title,
                style: 'header'
            },
            {
                text: date,
                style: 'dateStyle'
            },
            {
                text: 'General Info',
                style: 'subheader'
            },
            {
                text: 'Name',
                style: 'labelStyle'
            },
            {
                text: req.user.name,
                style: 'fieldStyle'
            },
            {
                text: 'Purpose of Payment',
                style: 'labelStyle'
            },
            {
                text: req.title,
                style: 'fieldStyle'
            },
            {
                text: 'Project Charged To',
                style: 'labelStyle'
            },
            {
                text: req.projectName,
                style: 'fieldStyle'
            },
            {
                text: "Bank Details",
                style: 'subheader'
            },
            {
                columns: [
                    [
                        {
                            text: 'Name of Beneficiary',
                            style: 'labelStyle',
                        },
                        {
                            text: req.accountName,
                            style: 'fieldStyle'
                        }
                    ],
                    [
                        {
                            text: 'Beneficiary Bank Name',
                            style: 'labelStyle',
                        },
                        {
                            text: req.bankName,
                            style: 'fieldStyle'
                        }
                    ],
                    [{
                        text: 'Beneficiary Account Number',
                        style: 'labelStyle',
                    },
                    {
                        text: req.accountNumber,
                        style: 'fieldStyle'
                    }

                    ]
                ],
            },
            {
                columns: SourceSection,
            },
            {
                text: 'Items',
                style: 'subheader'
            },
            {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: ['*', 'auto', 50],
                    body: itemsDoc
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex % 2 === 0) ? '#CCCCCC' : null;
                    }
                }
            },
            {
                columns: [
                    [{ text: 'Total', style: 'labelStyle' }, { text: accounting.formatMoney(req.total, currencyCodes[req.currency]), style: 'fieldStyle' }],
                    [{ text: 'Amount In Words', style: 'labelStyle' }, { text: req.amountInWords, style: 'fieldStyle' }]
                ]
            },
            {
                columns: SignatureSection
            },
            ...convos
        ],
        
        styles: {
            reference: {
                color: '#08713E'
            },
    
            header: {
                fontSize: 24,
                alignment: 'center',
                margin: [0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                color: "#CEAFE7",
                margin: [0, 15]
            },
            labelStyle: {
                bold: true,
                fontSize: 10,
                margin: [0, 10, 0, 3]
            },
            fieldStyle: {
                fontSize: 12,
                margin: [0, 3, 0, 5],
                color: "#B7ADAD"
            },
            tableExample: {
                margin: [0, 10]
            },
            tableBodyText: {
                fontSize: 10,
                italics: true,
            },
            dateStyle: {
                alignment: 'center',
                fontSize: '10',
                bold: true,
                color: "#CEAFE7"
            },
            chatDateStyle:{
                fontSize: '10',
                bold: true,
                color: "#CEAFE7",
                margin: [0, 10,0,3]
            },
            footerStyle: {
                alignment: 'center',
                fontSize: 8,
                margin: [0, 0],
                italics: true,
                color: '#CEAFE7'
            }
        },
       


    }
    
    return dd;
}

const tobase64 = (url)=>{
    return new Promise((resolve, reject)=>{
        let canvas = document.createElement('canvas');
        let img = document.createElement('img');
        var ctx = canvas.getContext('2d');
        console.log(url);
        img.setAttribute('src', url);
        img.crossOrigin = "anonymous";
        img.onload = function(){
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            let dataUrl = canvas.toDataURL('image/png');
            resolve(dataUrl);
        }
        img.onerror = function(e){
            console.log(e);
            resolve("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQwAAAC8CAMAAAC672BgAAABGlBMVEX///9YrjnF1vPr6+vk5OSdnZ3D1POvsLHI2fTt9P7l6O/k7fzu7u7n7/rV4vd6eXx+h3tul2DKzNBgpUjc6PvS4fn5+fmWlpfR3vOJiYqgoKH1+P3CytewsrbV2d+RkZLV1dXA1Oxcr0Hy+fDExMW3t7i70uSyztabxq55unKoycaorbW8xNN8v2P6/fmqq6vKz9nI0uO7vsPV3u2zzdmnycOaxqyiyLqOv5mBuoN8uXmHvYxhrUtqs1pztWi30dKRxI611rnb6eeMxXu4267R6Mmo1Jjh8NzG47tzu1nF39HO4eiGxHCjz5yo0LGrvLuVo5mataKNn4yMr4qDo359rnV2r2rG1sCEl4GTvIWrtKeTqYt6nG69x7rFCBnUAAAEX0lEQVR4nO3a61/aVhzHcTUgsFy6UUjC1QAJNy1RRFAuYgdIrdZZq1u7dv//v7HfOQmFeNserPpazvf9pC8hD5LP63eSE+3aGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAf0OPPE1S9Jc+xeejGNEnxZKSLkwOJZp13dgjXDcbswUaDooRaycf0Y5FXce2IqLUoBhO8qdHJJ0oDY4jzEqhGO2imniQWqQYbkyc2WAxdlVVle+hD4sFNjdW0k5akgg1eAxZTj1AlncLUdeWJMuh26gIs6EYFIOuXGNYABZG837apxixpKJHbLZSBHiosBh5uvw0k5L5rcL7SUtp+YLBYigRy7IpR+hvoxSjkNdS6XScrl9OsI9yspdGM/PbhsseJbpiOa5tKcpLn+0P9j0GGwU1xz7KqawGxWExso5Fm3LLjtH2y7JCPhpeDM1bIzkeQ8/l1NQihpH19qJRgzYcTshHg95N/BjeWHhyqraIYfCXF/5PNiq93Ik+By8Ge5Am7sfY2yksuTQdYsRQ/SXiYzHiadPc390tLiSdrBgxaCz0FeyBEo/HTTPFN6KEnrjFtiAxUv41L8h0A2U1/G2YtzcXJcY9vAUtFL4t5VtzeVeAGFve0yT+IHrImKa/U6cYW+GPsZ03H4vhB+E7srwQMQp5M/1EDL8IvagIEMPY5jE2nsJi7LVjbth3oF6M+D/EiKe1/WIyGfZ3k38Vg0ZDk9Xwv7X6MVavvMQFYqS1wHY9pFiMHRZjc4FiVJlSaXP5WVoO7tfD6U4MPhadGulUSxubi0TxVOKlT/Q5BGKUStXO+KDXq3e79XrvoFnzxoPdMMI/FmvLGHwAqp1m7/Co32+Q/tHgsN7sUI0NU1YFWCNEWolR6jTrg+Nh2TMcHR9RjWopnvJLhP4XwlJmEaNarfW6g/6ovO5hNQbd3njf/9WoLkUiIa8hZba8GKUajUV/NFy0WPeG4+Ttr/4zNWI5Yd+Bfo9RbdYPl2OxGI7hZDr3DtQjdjTs7yZeDJPWSHfQGA0DLdbPLibTWYUdlsslim0jI0aMWrNHt87hncF4czqbV1rssJwq5wuCxDgf9w4bo+BYlMtnk3d8LFqtVkLWdrbFiLE35vfOYIuzyel0zsaiNZ+9fX/O/ogiQoz2+Xuai7tr5GJKa4QdUpl9OLkcm2JMhvvb+PJoVC4H54LuF3wsKpXZtHE86J2LMRlXHy9PGsG5KL+ZnL7ja4RSnE5Go/5h7+BqS4AY15+OGnc2GHTr9B8j8+nFGW3QR/0Pn64FiJH5fHP7+/HrFaMzf6ulK9IfX/hXx7cDMWL8/Pnm5tsvS7dfTv2tlmTZf37lX327+Xp9lQl9jFcZyhFw9de8wteIHnGM5Xd0XPhj3GPY/vuYbrmZ1S8yryIve7I/mi7ds/xffXTPCAr5KzwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwP/a38wtqoLPT/bDAAAAAElFTkSuQmCC");
        }
    });
}

export const sendMail = async(req, auth)=>{
    
    let message = `${auth.myuser.name} sent back the requisition titled ${req.title}. Login to gwapp to treat`;
    let title = "Requistion Alert"
    let name = auth.myuser.name;
    let to = req.attentionTo?  req.attentionTo : [];
    to = [...to, auth.email];
    to = to.join(', ')
    console.log(to);

    let link = ABS_PATH;
    console.log({ message, title, name, to, link });
    let url = cloudURL + 'sendMail';
    axios.post(url, { message, title, name, to, link }).then((response) => {
        console.log('success');
        console.log(response);
    })
    
}

export const cloudURL = window.location.host === "localhost:3000" ?
 "http://localhost:5001/auth-f9812/us-central1/":
  "https://us-central1-auth-f9812.cloudfunctions.net/";